import { createStyles, makeStyles, Theme } from "@material-ui/core";
import CircleIcon from "@material-ui/icons/FiberManualRecord";
import { FONTS } from "../../constants";
import { TEXT_COLOR } from "../PersonaGroupings/clusterChart/ClusterChart";
type legendInputType = { labels: string[]; colors: string[] };

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      height: "50px",
      display: "flex",
      flexDirection: "row",
      marginTop: "50px",
      marginRight: "50px",
      marginBottom: "-180px",
      fontFamily: FONTS,
      zIndex: 1000,
    },
    legendItem: {
      display: "flex",
      flexDirection: "row",

      marginRight: "20px",
      alignItems: "center",
    },
    legendTitle: { fontSize: "20px", marginBottom: "10px", color: "white" },
  })
);

type itemType = { label: string; color: string };

export function LegenItem({ label, color }: itemType) {
  const classes = useStyles();
  return (
    <div className={classes.legendItem}>
      <CircleIcon
        style={{ color: color, height: "25px", width: "25px" }}
      ></CircleIcon>
      <div style={{ marginTop: "0px", marginLeft: "5px", color: TEXT_COLOR }}>
        {label}
      </div>
    </div>
  );
}

export function Legend({ labels, colors }: legendInputType) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {labels.map((label, i) => {
        return <LegenItem label={label} color={colors[i]}></LegenItem>;
      })}{" "}
    </div>
  );
}
